import { render, staticRenderFns } from "./AccountContentToDisplay.vue?vue&type=template&id=6885bfc1&scoped=true&"
import script from "./AccountContentToDisplay.vue?vue&type=script&lang=js&"
export * from "./AccountContentToDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AccountContentToDisplay.vue?vue&type=style&index=0&id=6885bfc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885bfc1",
  null
  
)

export default component.exports